import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    headingWrapper: {
        ...flex('row', 'space-between', 'center'),
        padding: `${theme.spacing(2)} ${theme.spacing(6)}`,
        [theme.down('desktop')]: {
            padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        },
    },

    titleWrapper: {
        ...flex('row', '', 'center'),
        flexGrow: 1,
        justifyContent: 'space-between',
        gap: theme.spacing(3),
        [theme.down('desktop')]: {
            flexWrap: 'wrap',
        },
    },

    addButton: {
        width: theme.spacing(12),
        minWidth: 'auto',
        height: theme.spacing(9),
        paddingRight: theme.spacing(2),
        margin: 0,
        marginLeft: theme.spacing(4),
        right: 0,
    },

    loader: {
        color: theme.colors.violet_primary,
    },
}));
